import { atom } from 'jotai';
import { InvoiceLineItemDispensesDataItem } from './invoice_line_item_dispenses_list_types';
import { TblView, TblStats, TableFilters, TableState, TableDataState } from '../../../core/table/table.types';
import { tableViewVM, tableStatsVM, tableStateVM } from '../../../core/table/table_view_models';

export const invoiceLineItemDispensesModelAtom = atom<InvoiceLineItemDispensesDataItem[]>([]);

export const invoiceLineItemDispensesDataAtom = atom<TableDataState<InvoiceLineItemDispensesDataItem>>({
    items: [],
    dataItems: [],
});
export const invoiceLineItemDispensesTableStateAtom = atom<TableState>(tableStateVM());
export const invoiceLineItemDispensesTableViewAtom = atom<TblView>(tableViewVM());
export const invoiceLineItemDispensesTableStatsAtom = atom<TblStats>(tableStatsVM());
export const invoiceLineItemDispensesTableFiltersAtom = atom<TableFilters>({});
